let isAnnual = true;

// Ustaw ceny roczne na starcie
document.querySelectorAll('.price-value').forEach(el => {
  el.textContent = el.dataset.annual;
});

function switchBilling(mode) {
  isAnnual = (mode === 'annual');
  var btnMonthly = document.getElementById('btn-monthly');
  var btnAnnual = document.getElementById('btn-annual');
  var saveBadge = document.getElementById('save-badge');

  btnMonthly.classList.toggle('active', !isAnnual);
  btnAnnual.classList.toggle('active', isAnnual);
  saveBadge.classList.toggle('visible', isAnnual);

  document.querySelectorAll('.price-value').forEach(function(el) {
    var val = isAnnual ? el.dataset.annual : el.dataset.monthly;
    if (val) el.textContent = val;
  });

  document.querySelectorAll('.annual-note').forEach(function(el) {
    el.textContent = isAnnual ? el.dataset.annualText : '';
  });
}

function switchSegment(segment) {
  // Toggle segment buttons
  document.querySelectorAll('.segment-btn').forEach(function(btn) {
    var on = btn.dataset.segment === segment;
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  // Toggle segment cards
  document.querySelectorAll('.pricing-segment').forEach(function(seg) {
    seg.classList.toggle('active', seg.id === 'segment-' + segment);
  });
}

// Bun bundles this file as an ES module (<script type="module">), so top-level
// function declarations are scoped to the module and never reach `window`.
// The inline onclick="..." handlers in index.html resolve against the global
// scope, so both handlers must be exposed on window explicitly.
window.switchBilling = switchBilling;
window.switchSegment = switchSegment;
